import { z } from 'zod';
import { AssistantError } from './assistant';
import {
  resolveResponseModel,
  responseModelEntry,
  type ResponseModelSettings,
} from './models';

export const modelCredentialModeSchema = z.enum(['platform', 'bot_required']);
const providerKeySchema = z.string().trim().min(1).max(4096);
export const modelCredentialsSchema = z
  .object({
    openaiKey: providerKeySchema,
    jevKey: providerKeySchema,
    // Needed only by bots whose response model Anthropic serves.
    anthropicKey: providerKeySchema.optional(),
  })
  .strict();
export type ModelCredentials = z.infer<typeof modelCredentialsSchema>;
export const updateModelCredentialsSchema = z
  .object({
    mode: modelCredentialModeSchema,
    openaiKey: providerKeySchema.optional(),
    jevKey: providerKeySchema.optional(),
  })
  .strict();
export const modelCredentialStatusSchema = z
  .object({
    mode: modelCredentialModeSchema,
    openaiConfigured: z.boolean(),
    jevConfigured: z.boolean(),
    updatedAt: z.iso.datetime({ offset: true }),
  })
  .strict();
export type ModelCredentialStatus = z.infer<typeof modelCredentialStatusSchema>;

// The key of the provider that serves the bot's response model.
export function responseModelKey(
  credentials: ModelCredentials,
  settings?: ResponseModelSettings
): string {
  const { provider } = responseModelEntry(resolveResponseModel(settings).model);
  if (provider === 'openai') return credentials.openaiKey;
  if (!credentials.anthropicKey)
    throw new AssistantError('ANTHROPIC_NOT_CONFIGURED', 503);
  return credentials.anthropicKey;
}
